import React from "react";
import { shape, number, arrayOf, string, bool } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { BrandsCarousel } from "./BrandsCarousel";

const BrandsNonStaticCarouselConnector = ({ displayTitle, hotelChains, entriesPerPage }) => {
	let hotels = hotelChains;

	const alphabetizedHotels = hotels
		.filter(hotel => !hotel.hotelChainPriority)
		.sort((a, b) => a?.title?.localeCompare(b?.title));

	const priorityHotels = hotels
		.filter(hotel => hotel.hotelChainPriority)
		.sort((a, b) => a?.hotelChainPriority - b?.hotelChainPriority);

	hotels = [...priorityHotels, ...alphabetizedHotels];

	const numSlides = Math.ceil(hotels.length / entriesPerPage);
	const slides = [];

	for (let i = 0; i < numSlides; i++) {
		const entries = hotels.slice(0, entriesPerPage);
		hotels = hotels.slice(entriesPerPage);

		slides.push(entries);
	}

	return <BrandsCarousel title={displayTitle} slides={slides} />;
};

BrandsNonStaticCarouselConnector.propTypes = {
	displayTitle: string,
	hotelChains: arrayOf(
		shape({
			id: string,
			node_locale: string,
			title: string,
			slug: string,
			hotelChainPriority: bool,
			logo: arrayOf(
				shape({
					secure_url: string,
				})
			),
		})
	),
	entriesPerPage: number,
};

BrandsNonStaticCarouselConnector.defaultProps = {
	displayTitle: null,
	hotelChains: [],
	entriesPerPage: null,
};

export default BrandsNonStaticCarouselConnector;
export { BrandsNonStaticCarouselConnector };
